import React from 'react';
import { ArrowUpOutlined, FireOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import { Label } from 'components/Statistic/Label';
import { Widget } from 'components/Statistic/Widget';
import cn from './styles.module.scss';

type PercentageDiffProps = {
  loading: boolean,
  items: Array<{
    title: string,
    diff: number
  }>
}

export function PercentageDiff({ loading, items = [] }: PercentageDiffProps) {
  return (
    <Widget>
      <Label>
        <FireOutlined /> Hottest
      </Label>
      <Skeleton loading={loading} paragraph={{ rows: 5, width: '100%'}} active />
      {items.map((item, index) => (
        <div key={index} className={cn.item}>
          <span>{item.title}</span>
          <div className={item.diff >= 0 ? cn.positive : cn.negative}>
            <ArrowUpOutlined />
            <span> {item.diff}%</span>
          </div>
        </div>
      ))}
    </Widget>
  );
}
